import { render, staticRenderFns } from "./WheelOfFortune.vue?vue&type=template&id=31a7836c&scoped=true&"
import script from "./WheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./WheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./WheelOfFortune.vue?vue&type=style&index=0&id=31a7836c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7836c",
  null
  
)

export default component.exports